export default __webpack_public_path__ + "static/media/jobFairTam.788b2585.png";